import { AuthProvider } from '@sdk/authentication/AuthContext';
import ToastComponent from '@sdk/common/toast/ToastComponent';
import { PersonaCollectionContext } from '@sdk/personaCollection/PersonaCollectionContext';

import { UserSettingsProvider } from '@web/settings/UserSettingsContext';
import { UserOrgSettingsProvider } from '@web/settings/UserOrgSettingsContext';
import EmployeePendingConsentTimesheetViewModal from '@web/timesheets/EmployeePendingConsentTimesheetViewModal/EmployeePendingConsentTimesheetViewModal';
import { QueryClientProvider } from '@web/components/QueryClientProvider/QueryClientProvider';

const EmployeePendingConsentTimesheetViewModalAngular = ({
  Authentication,
  PersonaCollection,
  shift,
  isTimesheetPreviewActive = false,
  onClose,
  onApprove,
  onDeny,
}) => (
  <AuthProvider currentUser={Authentication.user}>
    <UserSettingsProvider settings={Authentication.user.settings}>
      <UserOrgSettingsProvider settings={Authentication.user.orgSettings}>
        <PersonaCollectionContext.Provider value={PersonaCollection}>
          <QueryClientProvider>
            <EmployeePendingConsentTimesheetViewModal
              shift={shift}
              isTimesheetPreviewActive={isTimesheetPreviewActive}
              onClose={onClose}
              onApprove={onApprove}
              onDeny={onDeny}
            />
          </QueryClientProvider>
          {/* @TODO: multiple toast containers causes mutliple toasts - think how to solve */}
          <ToastComponent />
        </PersonaCollectionContext.Provider>
      </UserOrgSettingsProvider>
    </UserSettingsProvider>
  </AuthProvider>
);

export default {
  ReactComponent: EmployeePendingConsentTimesheetViewModalAngular,
  dependencies: ['Authentication', 'PersonaCollection'],
  bindings: {
    shift: '<',
    isTimesheetPreviewActive: '<',
    onClose: '&',
    onApprove: '&',
    onDeny: '&',
  },
};
